import React from 'react';
import ButtonLink from '../../../elements/ButtonLink';
import { useI18n } from '../../../../data/hooks/i18nHooks';

function StartNetworkingFooterButton(props) {
    const { event, absolutePath = false } = props,
        i18n = useI18n();

    if (!event) return null;

    return (
        <ButtonLink
            style={{
                ...(event._local.styles.button || {}),
            }}
            href={[absolutePath ? `/events/${event.id}` : '.', 'start-networking'].join('/')}>
            {i18n['label.start-networking']}
        </ButtonLink>
    );
}

export default StartNetworkingFooterButton;
